<app-modal></app-modal>
<app-charging [isLoading]="isLoading"></app-charging>

<ng-container *ngIf="!isLoading">

  <div class="role-banner" *ngIf="(loginRole && !bannerClosed) || isClosingBanner"
    [class.show]="!isClosingBanner" [class.hide]="isClosingBanner">
    <p class="banner-text">
      Bienvenido, usted ha ingresado como <strong>{{getRoleName(loginRole)}}</strong>
    </p>
    <button class="close-banner" (click)="closeBanner()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="home-container" *ngIf="quoteData && propertyData">
    <section class="property-info">
      <h2 class="property-owner">
        <strong>COTIZADOR:</strong> {{ quoteData.strContactName }}
      </h2>
      <div class="property-details">
        <div *ngIf="quoteData.strContactAddress">
          <strong>Dirección del Inmueble:</strong> {{ quoteData.strContactAddress }}
        </div>
        <div *ngIf="quoteData?.inTypeHousing">
          <strong>Destino del Inmueble:</strong>
          {{ getPropertyDestination(quoteData.inTypeHousing) }}
        </div>
        <div *ngIf="propertyData?.inCodPropertyDeparment">
          <strong>Departamento:</strong>
          {{ getDepartmentName(propertyData.inCodPropertyDeparment) }}
        </div>
        <div *ngIf="propertyData?.inCodPropertyMunicipality">
          <strong>Ciudad/Municipio:</strong>
          {{ getMunicipalityName(propertyData.inCodPropertyMunicipality) }}
        </div>
        <div *ngIf="propertyData?.inCodLeasingProperty">
          <strong>Arrendamiento del Inmueble:</strong>
          {{ getPropertyLeaseType(propertyData.inCodLeasingProperty) }}
        </div>
        <div *ngIf="quoteData.dcLeaseFeeValue">
          <strong>Arrendamiento Mensual:</strong>
          {{ propertyData.dcLeaseFeeValue | currency:'USD':'symbol' }}
        </div>
        <div *ngIf="quoteData.dcAdministrationFee">
          <strong>Cuota de Administración:</strong>
          {{ propertyData.dcAdministrationFee | currency:'USD':'symbol' }}
        </div>
        <div *ngIf="propertyData?.inCodPropertyType">
          <strong>Tipo de inmueble:</strong>
          {{ getPropertyType(propertyData.inCodPropertyType) }}
        </div>
      </div>
    </section>
  </div>

  <div class="cards">
    <!-- Card Propietario -->
    <div class="card" *ngIf="loginRole === 2 || (loginRole === 1 && isLinked === 0)">
      <div class="card-header">
        <div class="avatar-container">
          <img src="assets/img/img0.jpg" alt="Propietario" class="avatar" />
        </div>
        <div class="header-text">
          <h3>
            <i *ngIf="loginRole === 2" class="fas fa-check-square main-role-indicator"></i>
            Propietario
          </h3>
          <p>{{getCompletedRequiredTaskCount(2)}}/{{getRequiredTaskCount(2)}} Tareas</p>
        </div>
      </div>

      <div class="progress-container">
        <div class="progress">
          <div class="progress-bar" [style.width.%]="getProgressPercentage(2)"></div>
        </div>
        <span class="progress-text">{{getProgressPercentage(2)}}%</span>
      </div>

      <div class="task-list">
        <ng-container *ngIf="tasksByRole[2]">
          <!-- Tareas dinámicas del propietario -->
          <div class="task-item" *ngFor="let task of tasksByRole[2]"
            [attr.data-tooltip]="task.description ? task.description : null"
            (click)="onTaskClick(task.type, 2, task.name, task.id)">
            <div class="task-status" [class.required]="task.required">
              <i class="fas" [ngClass]="{
                'fa-check-circle text-success': task.completed,
                'fa-times-circle': !task.completed && task.required,
                'fa-exclamation-circle': !task.completed && !task.required
              }"></i>
            </div>
            <div class="task-type">
              <i class="fas" [ngClass]="task.icon"></i>
            </div>
            <span class="task-name">{{task.name | titlecase}}</span>
          </div>

          <ng-container *ngIf="loginRole === 2 && isLinked === 0 && isContactInfoAvailable(2)">
            <div class="task-item" (click)="onTaskClick('sendLink',2,null,null,1)">
              <div class="task-status optional">
                <i class="fas fa-bell"></i>
              </div>
              <div class="task-type">
                <i class="fas fa-link"></i>
              </div>
              <span class="task-name">Vínculo Arrendatario</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Card Arrendatario -->
    <div class="card" *ngIf="loginRole === 1 || (loginRole === 2 && isLinked === 0)">
      <div class="card-header">
        <div class="avatar-container">
          <img src="assets/img/img1.jpg" alt="Arrendatario" class="avatar" />
        </div>
        <div class="header-text">
          <h3>
            <i *ngIf="loginRole === 1" class="fas fa-check-square main-role-indicator"></i>
            Arrendatario
          </h3>
          <p>{{getCompletedRequiredTaskCount(1)}}/{{getRequiredTaskCount(1)}} Tareas</p>
        </div>
      </div>

      <div class="progress-container">
        <div class="progress">
          <div class="progress-bar" [style.width.%]="getProgressPercentage(1)"></div>
        </div>
        <span class="progress-text">{{getProgressPercentage(1)}}%</span>
      </div>

      <div class="task-list">
        <ng-container *ngIf="tasksByRole[1]">

          <!-- Tareas dinámicas del arrendatario -->
          <div class="task-item" *ngFor="let task of tasksByRole[1]"
            [attr.data-tooltip]="task.description ? task.description : null"
            (click)="onTaskClick(task.type, 1, task.name, task.id)">
            <div class="task-status" [class.required]="task.required">
              <i class="fas" [ngClass]="{
                'fa-solid fa-clock icon-pending': !task.sended && task.completed && task.type == 'application-form',
                'fa-check-circle text-success': (task.completed && task.type != 'application-form') || (task.completed && task.type == 'application-form' && task.sended),
                'fa-times-circle': !task.completed && task.required,
                'fa-exclamation-circle': !task.completed && !task.required
              }"></i>
            </div>
            <div class="task-type">
              <i class="fas" [ngClass]="task.icon"></i>
            </div>
            <span class="task-name">{{task.name | titlecase}}</span>
            <button *ngIf="task.type === 'application-form' && task.completed" 
              class="sign-button" 
              (click)="onStartSigningProcess($event, 1)">
              <i class="fa-solid fa-file-signature"></i>
            </button>
          </div>

          <!-- Vínculo de propietario (Opcional) -->
          <ng-container *ngIf="isTenantInfoMainRole(1)">
            <div class="task-item" (click)="onTaskClick('sendLink', 1, null, null, 2)">
              <div class="task-status optional">
                <i class="fas fa-bell"></i>
              </div>
              <div class="task-type">
                <i class="fas fa-link"></i>
              </div>
              <span class="task-name">Vínculo Propietario</span>
            </div>
          </ng-container>

          <!-- Vínculos de codeudores -->
          <ng-container *ngIf="isContactInfoAvailable(1)">
            <div class="task-item" *ngFor="let codeudor of codeudores; let i = index"
              (click)="onTaskClick('sendLink',1,null,null, i + 3)">
              <div class="task-status optional">
                <i class="fas fa-bell"></i>
              </div>
              <div class="task-type">
                <i class="fas fa-link"></i>
              </div>
              <span class="task-name">Vínculo Codeudor {{i + 1}}</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Cards de Codeudores -->
    <div class="card" *ngFor="let codeudor of filteredCodeudores; let i = index">
      <div class="card-header">
        <div class="avatar-container">
          <img src="assets/img/img2.jpg" class="avatar" alt="Codeudor">
        </div>
        <div class="header-text">
          <h3>
            <i *ngIf="(loginRole === 3 || loginRole === 4)"
              class="fas fa-check-square main-role-indicator"></i>
            Codeudor {{((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 1 : loginRole! - 2}}
          </h3>
          <p>{{getCompletedRequiredTaskCount(((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked ===
            0)) ? i + 3 : loginRole!)}}/{{getRequiredTaskCount(((loginRole === 2 && isLinked === 0) || (loginRole === 1
            && isLinked === 0)) ? i + 3 : loginRole!)}} Tareas</p>
        </div>
      </div>

      <div class="progress-container">
        <div class="progress">
          <div class="progress-bar"
            [style.width.%]="getProgressPercentage(((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 3 : loginRole!)">
          </div>
        </div>
        <span class="progress-text">{{getProgressPercentage(((loginRole === 2 && isLinked === 0) || (loginRole === 1 &&
          isLinked === 0)) ? i + 3 : loginRole!)}}%</span>
      </div>

      <div class="task-list">
        <ng-container
          *ngIf="tasksByRole[((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 3 : loginRole!]">
          <!-- Tareas dinámicas del codeudor -->
          <div class="task-item"
            *ngFor="let task of tasksByRole[((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 3 : loginRole!]"
            [attr.data-tooltip]="task.description ? task.description : null"
            (click)="onTaskClick(task.type, ((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 3 : loginRole!, task.name, task.id)">
            <div class="task-status" [class.required]="task.required">
              <i class="fas" [ngClass]="{
                'fa-solid fa-clock icon-pending': !task.sended && task.completed && task.type == 'application-form',
                'fa-check-circle text-success': (task.completed && task.type != 'application-form') || (task.completed && task.type == 'application-form' && task.sended),
                'fa-times-circle': !task.completed && task.required,
                'fa-exclamation-circle': !task.completed && !task.required
              }"></i>
            </div>
            <div class="task-type">
              <i class="fas" [ngClass]="task.icon"></i>
            </div>
            <span class="task-name">{{task.name | titlecase}}</span>
            <button *ngIf="task.type === 'application-form' && task.completed" 
              class="sign-button" 
              (click)="onStartSigningProcess($event, ((loginRole === 2 && isLinked === 0) || (loginRole === 1 && isLinked === 0)) ? i + 3 : loginRole!)">
              <i class="fa-solid fa-file-signature"></i>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<app-upload-document [isVisible]="showUploadModal" [title]="selectedTaskTitle!" [roleName]="selectedRoleName"
  [taskId]="selectedTaskId!" [roleId]="selectedRoleId!" (close)="showUploadModal = false"
  (documentSaved)="onDocumentSaved()">
</app-upload-document>